var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9839 19.296L12.1439 15.456C12.0479 15.36 11.9999 15.2427 11.9999 15.104C11.9999 14.9653 12.0479 14.848 12.1439 14.752C12.2399 14.6453 12.3572 14.592 12.4959 14.592C12.6346 14.592 12.7519 14.6453 12.8479 14.752L15.4879 17.376V8H16.4959V17.376L19.1359 14.752C19.2319 14.6453 19.3492 14.592 19.4879 14.592C19.6266 14.592 19.7439 14.6453 19.8399 14.752C19.9359 14.848 19.9839 14.9653 19.9839 15.104C19.9839 15.2427 19.9359 15.36 19.8399 15.456L15.9839 19.296ZM11.5039 24V23.008H20.4959V24H11.5039Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadResult);
export default __webpack_public_path__ + "static/media/download_result.5f24d8bd682bb009002cdc7666267ca4.svg";
export { ForwardRef as ReactComponent };